module.exports = __webpack_public_path__ + "static/media/autochilango-parking-selected.e790f480.svg";